import {event} from '@fullstory/browser';

// Deprecated since it was generating way too many useless custom events
export const fsLogPageView = (pageName, properties = {}) => { // eslint-disable-line
    return null;
};

export const fsCustomEvent = (eventName, option = {}) => {
    if (eventName) {
        event(eventName, option);
    }
};

export default {fsLogPageView};